import { NgModule, Injectable, bundle } from 'ng-metadata/core';

// Media Content Document
import { MediaDocumentComponent } from './media-document.component';
import { ContentDocumentComponent } from './media-document.component';
import { ContentDocumentAdapterPipe } from './adapter/content-document-adapter.pipe';
import { ContentDocumentAdapterModule } from './adapter/content-document-adapter.module';
// Media Content Document Atoms
import { BodyComponent } from './body/body.component';
import { DuplicateDocsComponent } from './duplicate-docs/duplicate-docs.component';
import { HeaderComponent } from './header/header.component';
import { IngressComponent } from './ingress/ingress.component';
import { MatchSentenceComponent } from './match-sentence/match-sentence.component';
import { MediaTypeIconComponent } from './media-type-icon/media-type-icon.component';
import { ReachComponent } from './reach/reach.component';
import { SentimentComponent } from './sentiment/sentiment.component';
import { SentimentMenuComponent } from './sentiment/sentiment.menu.component';
import { SocialEchoComponent } from './social-echo/social-echo.component';
import { SocialEngagementComponent } from './social-engagement/social-engagement.component';
import { SourceCountryComponent } from './source-country/source-country.component';
import { SourceNameComponent } from './source-name/source-name.component';
import { TagsComponent } from './tags/tags.component';
import { TimestampComponent } from './timestamp/timestamp.component';
import { SentimentSelectorComponent } from './sentiment/sentiment.selector.component';


/**
 * @ngdoc module
 * @name mw.components.mediaContentDocuments
 * @description
 *
 */
@NgModule({
    imports: [ContentDocumentAdapterModule.name],
    declarations: [
        MediaDocumentComponent,
        ContentDocumentComponent,
        ContentDocumentAdapterPipe,
        BodyComponent,
        DuplicateDocsComponent,
        HeaderComponent,
        IngressComponent,
        MatchSentenceComponent,
        MediaTypeIconComponent,
        ReachComponent,
        SentimentComponent,
        SentimentMenuComponent,
        SentimentSelectorComponent,
        SocialEchoComponent,
        SocialEngagementComponent,
        SourceCountryComponent,
        SourceNameComponent,
        TagsComponent,
        TimestampComponent
    ]
})
export class MediaContentDocumentModule {}



// WEBPACK FOOTER //
// ./src/lib/components/content-documents/media-document/media-document.module.ts